import axios from 'axios';
import Config from '../config';
/**
 * @type {AxiosInstance}
 */
const $axios = axios.create({
    baseURL: Config.apiBaseUrl,
});
/**
 * @type {AxiosInstance}
 */
const $reservationAxios = axios.create({
    baseURL: Config.reservationApiBaseUrl,
});
export default $axios;
export const reservationAxios = $reservationAxios;
